import { Link } from "@/components/ui/link";
import ArrowLeftIcon from "lucide-solid/icons/arrow-left";

export default function NotFound() {
  return (
    <main class="grid grow place-items-center bg-background px-6 py-24 sm:min-h-[900px] sm:py-32 lg:px-8">
      <div class="text-center">
        <h1 class="mt-4 text-balance font-semibold text-5xl text-foreground tracking-tight sm:text-7xl">
          Page not found
        </h1>
        <p class="mt-6 text-pretty font-medium text-lg text-muted-foreground sm:text-xl/8">
          Sorry, we couldn’t find the page you’re looking for.
        </p>
        <div class="mt-8 flex items-center justify-center gap-x-6">
          <Link href="/" class="font-semibold">
            <ArrowLeftIcon class="mr-2 h-4 w-4" />
            Go home
          </Link>
        </div>
      </div>
    </main>
  );
}
